import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { ComponentService } from "../../../services/component.service";
import { UtilityService } from "../../../services/utility.service";
import { DepositOriginService } from '../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../services/deposit-origin';
let ConvertWalletModalComponent = class ConvertWalletModalComponent {
    constructor(sanitizer, httpClient, compService, themeService, location, utilityService, depositOriginService) {
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.compService = compService;
        this.themeService = themeService;
        this.location = location;
        this.utilityService = utilityService;
        this.depositOriginService = depositOriginService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.step = 1;
        this.loaded = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.sendButtonDisabled = true;
        this.orderAlreadyCreatedError = false;
        this.sendButtonClicked = false;
        this.errorMessage = '';
        this.minAmount = 0;
        this.maxAmount = 0;
        this.feePercentage = 0;
        this.fromCurrency = {};
        this.toCurrency = {};
        this.baseCurrencyAmount = 0;
        this.quoteCurrencyAmount = 0;
        this.availableBalance = 0;
        this.showToDropdown = false;
        this.showFromDropdown = false;
        this.fromCurrencies = [];
        this.toCurrencies = [];
        this.wallet = {};
        this.destinationWallet = {};
        this.withdrawError = false;
        this.maxValidAmount = true;
        this.minValidAmount = true;
        this.orderType = 'convert';
        this.meanOfPayment = 'bank_slip';
        this.currenciesFromWalletsWithFunds = [];
        this.decimalStep = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.availableBalance = this.data.walletData.spendableTotal;
        const fromCurrencyObj = this.data.convertPairs.filter(p => p.baseCurrency.code === this.data.walletData.currency.verboseId)[0];
        this.fromCurrency = fromCurrencyObj.baseCurrency;
        this.lotSize = fromCurrencyObj.lotSize;
        for (let i = 1; i <= this.lotSize; i++) {
            this.decimalStep += i != this.lotSize ? '0' : '1';
        }
        this.currenciesFromWalletsWithFunds = this.data.wallets
            .filter(w => { var _a, _b; return ((_a = w.wallet) === null || _a === void 0 ? void 0 : _a.spendableTotal) > 0 && ((_b = w.wallet) === null || _b === void 0 ? void 0 : _b.currency.fiat) === false; })
            .map(w => w.wallet.currency);
        this.getToCurrencies(this.fromCurrency, true);
        this.loaded = true;
    }
    getToCurrencies(fromCurrency, setFromCurrencies = false) {
        this.toCurrencies = this.data.convertPairs
            .filter(p => p.baseCurrency.code === fromCurrency.code)
            .map(p => p.quoteCurrency);
        if (!this.toCurrency || !this.toCurrencies.some(c => c.code === this.toCurrency.code)) {
            this.toCurrency = this.toCurrencies[0];
        }
        this.setLotSize();
        if (setFromCurrencies) {
            this.fromCurrencies = this.data.convertPairs
                .map(p => p.baseCurrency)
                .filter(base => this.currenciesFromWalletsWithFunds.some(c => c.verboseId === base.code))
                .filter((base, index, self) => index === self.findIndex(b => b.code === base.code));
        }
        this.getMarketSettings();
    }
    getFromCurrencies() {
        this.fromCurrencies = this.data.convertPairs
            .map(p => p.baseCurrency)
            .filter(base => this.currenciesFromWalletsWithFunds.some(c => c.verboseId === base.code))
            .filter((base, index, self) => index === self.findIndex(b => b.code === base.code));
        if (!this.fromCurrencies.some(c => c.code === this.fromCurrency.code)) {
            this.fromCurrency = this.fromCurrencies[0];
        }
        this.setLotSize();
        this.getMarketSettings();
    }
    getMarketSettings() {
        this.httpClient.get('wallet/getmarketsettings?baseCurrency=' + this.fromCurrency.code + '&meanOfPayment=' + this.meanOfPayment + '&quoteCurrency=' + this.toCurrency.code + '&orderType=' + this.orderType).subscribe((data) => {
            this.minAmount = Number(data['min_amount']);
            this.maxAmount = Number(data['max_amount']);
            this.feePercentage = Number(data['fee']);
            this.checkValidation();
        });
    }
    calculateAmountReceived() {
        const params = {
            user_id: this.user.id,
            order_type: this.orderType,
            base_currency_amount: this.baseCurrencyAmount,
            quote_currency_amount: this.quoteCurrencyAmount,
            base_currency: this.fromCurrency.code,
            quote_currency: this.toCurrency.code,
            mean_of_payment: this.meanOfPayment,
            fees: {
                fee_percent: this.feePercentage,
                fixed_fee: 0,
                min_fee: 0
            }
        };
        this.httpClient.post('wallet/order/calculate-amount-and-total', params).subscribe((data) => {
            this.quoteCurrencyAmount = data[0]['quoteCurrencyAmount'];
        });
    }
    setMaxAmount() {
        this.baseCurrencyAmount = this.utilityService.truncateDataBasedOnPrecision(this.availableBalance, this.lotSize);
        this.checkValidation();
    }
    toggleFromDropdown() {
        this.showFromDropdown = !this.showFromDropdown;
        this.showToDropdown = false;
    }
    toggleToDropdown() {
        this.showToDropdown = !this.showToDropdown;
        this.showFromDropdown = false;
    }
    selectFromCurrency(currency, event) {
        if (event) {
            event.stopPropagation();
        }
        this.fromCurrency = currency;
        this.showFromDropdown = false;
        this.wallet = this.data.wallets.find(wallet => wallet.wallet.currency.verboseId === this.fromCurrency.code);
        this.availableBalance = this.wallet.spendableTotal;
        this.getToCurrencies(currency);
    }
    selectToCurrency(currency, event) {
        if (event) {
            event.stopPropagation();
        }
        this.toCurrency = currency;
        this.showToDropdown = false;
        this.getFromCurrencies();
    }
    close() {
        this.modal.destroy();
    }
    confirmConvert() {
        if (this.sendButtonDisabled) {
            return;
        }
        this.step = 2;
        this.loaded = false;
        this.httpClient.get('market/price/' + this.fromCurrency.code.toLowerCase() + '/' + this.toCurrency.code.toLowerCase()).subscribe((data) => {
            this.currencyPrice = data['rsd_price'];
            this.loaded = true;
        });
    }
    convertCrypto() {
        var _a;
        if (this.sendButtonDisabled || this.orderAlreadyCreatedError) {
            return;
        }
        this.sendButtonClicked = true;
        this.wallet = this.data.wallets.filter(wallet => wallet.wallet.currency.verboseId === this.fromCurrency.code)[0];
        this.destinationWallet = this.data.wallets.filter(wallet => wallet.wallet.currency.verboseId === this.toCurrency.code)[0];
        const convertData = {
            baseCurrencyAmount: this.baseCurrencyAmount,
            quoteCurrencyAmount: this.quoteCurrencyAmount,
            baseCurrency: this.fromCurrency.code,
            quoteCurrency: this.toCurrency.code,
            walletId: this.wallet.wallet.verboseId,
            destinationWalletId: (_a = this.destinationWallet) === null || _a === void 0 ? void 0 : _a.wallet.verboseId
        };
        this.httpClient.post('wallet/convert', convertData).subscribe((data) => {
            this.close();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'convert',
                isSuccess: true
            });
        }, (error) => {
            this.errorMessage = error.error['message'];
            if (isDepositOriginCode(this.errorMessage)) {
                // the deposit trigger wants the statement or the proof of origin: its window instead of an error
                this.close();
                this.depositOriginService.openForCode(this.errorMessage);
                return;
            }
            if (this.errorMessage === 'ORDER_ALREADY_CREATED') {
                this.orderAlreadyCreatedError = true;
                setTimeout(() => {
                    this.orderAlreadyCreatedError = false;
                }, 30000);
            }
            else {
                this.withdrawError = true;
            }
            this.sendButtonClicked = false;
        });
    }
    checkValidation(skipCalculation = false) {
        if (!this.baseCurrencyAmount || typeof this.baseCurrencyAmount === 'undefined' || this.baseCurrencyAmount <= 0) {
            this.minValidAmount = true;
            this.maxValidAmount = true;
            if (!this.baseCurrencyAmount) {
                this.quoteCurrencyAmount = null;
            }
            this.sendButtonDisabled = true;
            return;
        }
        if (this.baseCurrencyAmount < this.minAmount) {
            this.minValidAmount = false;
            this.maxValidAmount = true;
            this.sendButtonDisabled = true;
            return;
        }
        if (this.baseCurrencyAmount > this.availableBalance || this.baseCurrencyAmount > this.maxAmount) {
            this.minValidAmount = true;
            this.maxValidAmount = false;
            this.sendButtonDisabled = true;
            return;
        }
        if (!skipCalculation && this.baseCurrencyAmount !== this.lastAmount) {
            this.calculateAmountReceived();
        }
        this.minValidAmount = true;
        this.maxValidAmount = true;
        this.sendButtonDisabled = false;
    }
    allowDecimalPoints(event) {
        const input = event.target;
        const value = input.value;
        if (this.lotSize === 0) {
            input.value = value.split('.')[0];
        }
        if (this.lotSize > 0) {
            const splitVal = value.split('.');
            if (splitVal.length > 1) {
                splitVal[1] = splitVal[1].slice(0, this.lotSize);
                input.value = `${splitVal[0]}.${splitVal[1]}`;
            }
        }
    }
    setLotSize() {
        this.lotSize = this.data.convertPairs.find(p => p.baseCurrency.code === this.fromCurrency.code && p.quoteCurrency.code === this.toCurrency.code).lotSize;
        for (let i = 1; i <= this.lotSize; i++) {
            this.decimalStep += i != this.lotSize ? '0' : '1';
        }
        if (this.baseCurrencyAmount) {
            this.baseCurrencyAmount = this.utilityService.truncateDataBasedOnPrecision(this.baseCurrencyAmount, this.lotSize);
        }
        if (this.quoteCurrencyAmount) {
            this.quoteCurrencyAmount = this.utilityService.truncateDataBasedOnPrecision(this.baseCurrencyAmount, this.lotSize);
        }
    }
};
ConvertWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: SharedHttp },
    { type: ComponentService },
    { type: WebsiteThemeService },
    { type: LocationStrategy },
    { type: UtilityService },
    { type: DepositOriginService }
];
ConvertWalletModalComponent = __decorate([
    Component({
        selector: 'app-convert-wallet-modal',
        template: __importDefault(require("./convert-wallet-modal.component.html")).default,
    })
], ConvertWalletModalComponent);
export { ConvertWalletModalComponent };
